import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import BaseMixin from '../_util/BaseMixin';
import { getOptionProps, initDefaultProps, getListeners, getComponentFromProp, isValidElement } from '../_util/props-util';
import getTransitionProps from '../_util/getTransitionProps';
import { ConfigConsumerProps } from '../config-provider';
import { previewImage, isImageUrl } from './utils';
import Icon from '../icon';
import Tooltip from '../tooltip';
import Progress from '../progress';
import classNames from 'classnames';
import { UploadListProps } from './interface';
import VueDraggable from 'vuedraggable';
import Gallery from './Gallery';
import throttle from 'lodash/throttle';

export default {
  name: 'FaUploadList',
  mixins: [BaseMixin],
  props: initDefaultProps(UploadListProps, {
    listType: 'text', // or picture
    progressAttr: {
      strokeWidth: 2,
      showInfo: false
    },
    showRemoveIcon: true,
    showDownloadIcon: false,
    showPreviewIcon: true,
    previewFile: previewImage
  }),
  data: function data() {
    return {
      dragging: false
    };
  },

  inject: {
    configProvider: { 'default': function _default() {
        return ConfigConsumerProps;
      } }
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      var _$props = _this.$props,
          listType = _$props.listType,
          items = _$props.items,
          previewFile = _$props.previewFile;

      if (listType !== 'picture' && listType !== 'picture-card' && listType !== 'draggable') {
        return;
      }
      (items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
          return;
        }
        /*eslint-disable */
        file.thumbUrl = '';
        if (previewFile) {
          previewFile(file.originFileObj).then(function (previewDataUrl) {
            // Need append '' to avoid dead loop
            file.thumbUrl = previewDataUrl || '';
            _this.$forceUpdate();
          });
        }
      });
    });
  },

  methods: {
    handlePreview: function handlePreview(file, e) {
      var _getListeners = getListeners(this),
          preview = _getListeners.preview;

      if (!preview) {
        return;
      }
      e.preventDefault();
      return this.$emit('preview', file);
    },
    handleDownload: function handleDownload(file) {
      var _getListeners2 = getListeners(this),
          download = _getListeners2.download;

      if (typeof download === 'function') {
        download(file);
      } else if (file.url) {
        window.open(file.url);
      }
    },
    handleClose: function handleClose(e, file) {
      e.stopPropagation();
      this.$emit('remove', file);
    },
    handleCustomActions: function handleCustomActions(e, file, index) {
      e.stopPropagation();
      this.$emit('custom-actions', {
        file: file,
        index: index
      });
    },
    handleInput: function handleInput(fileList) {
      this.$emit('drag', {
        fileList: fileList
      });
    },
    handleStart: function handleStart(e) {
      this.dragging = true;

      this.$emit('drag-start', e);
    },
    handleEnd: function handleEnd(e) {
      this.dragging = false;

      this.$emit('drag-end', e);
    },
    handleListItemClick: function handleListItemClick(file, e) {
      this.$emit('file-list-item-click', {
        file: file,
        e: e
      });
    },
    handleListItemRetryClick: function handleListItemRetryClick(file, e) {
      this.$emit('file-list-item-retry-click', {
        file: file,
        e: e
      });
    },
    slideToFirst: function slideToFirst() {
      this.$refs.gallery.slideToFirst();
    },
    slideToLast: function slideToLast() {
      this.$refs.gallery.slideToLast();
    },

    scrollFn: throttle(function (offsetX) {
      offsetX < 0 && this.$refs.gallery.slideToPrev();
      offsetX > 0 && this.$refs.gallery.slideToNext();
    }, 500)
  },
  render: function render() {
    var _this2 = this,
        _classNames4,
        _classNames5;

    var h = arguments[0];

    var _getOptionProps = getOptionProps(this),
        customizePrefixCls = _getOptionProps.prefixCls,
        _getOptionProps$items = _getOptionProps.items,
        items = _getOptionProps$items === undefined ? [] : _getOptionProps$items,
        listType = _getOptionProps.listType,
        showPreviewIcon = _getOptionProps.showPreviewIcon,
        showRemoveIcon = _getOptionProps.showRemoveIcon,
        showDownloadIcon = _getOptionProps.showDownloadIcon,
        locale = _getOptionProps.locale,
        progressAttr = _getOptionProps.progressAttr,
        draggable = _getOptionProps.draggable,
        listWidth = _getOptionProps.listWidth,
        listOuterWidth = _getOptionProps.listOuterWidth,
        listViewLength = _getOptionProps.listViewLength,
        removeIconSlot = _getOptionProps.removeIconSlot;

    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('upload', customizePrefixCls);

    var list = items.map(function (file) {
      var _classNames, _classNames2, _classNames3;

      var progress = void 0;
      var icon = h(Icon, {
        attrs: { type: file.status === 'uploading' ? 'loading' : 'paper-clip' }
      });

      if (listType === 'picture' || listType === 'picture-card' || listType === 'draggable') {
        if ((listType === 'picture-card' || listType === 'draggable') && file.status === 'uploading') {
          icon = h(
            'div',
            { 'class': prefixCls + '-list-item-uploading-text' },
            [locale.uploading]
          );
        } else if (!file.thumbUrl && !file.url) {
          icon = h(Icon, { 'class': prefixCls + '-list-item-thumbnail', attrs: { type: 'picture', theme: 'twoTone' }
          });
        } else {
          var thumbnail = isImageUrl(file) ? h('img', {
            attrs: {
              src: file.thumbUrl || file.url,
              alt: file.name
            },
            'class': prefixCls + '-list-item-image'
          }) : h(Icon, {
            attrs: { type: 'file', theme: 'twoTone' },
            'class': prefixCls + '-list-item-icon' });
          icon = listType === 'draggable' ? thumbnail : h(
            'a',
            {
              'class': prefixCls + '-list-item-thumbnail',
              on: {
                'click': function click(e) {
                  return _this2.handlePreview(file, e);
                }
              },
              attrs: {
                href: file.url || file.thumbUrl,
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            },
            [thumbnail]
          );
        }
      }

      if (file.status === 'uploading') {
        var progressProps = {
          props: _extends({}, progressAttr, {
            type: 'line',
            percent: file.percent
          })
        };
        // show loading icon if upload progress listener is disabled
        var loadingProgress = 'percent' in file ? h(Progress, progressProps) : null;

        progress = h(
          'div',
          { 'class': prefixCls + '-list-item-progress', key: 'progress' },
          [loadingProgress]
        );
      }
      var infoUploadingClass = classNames((_classNames = {}, _defineProperty(_classNames, prefixCls + '-list-item', true), _defineProperty(_classNames, prefixCls + '-list-item-' + file.status, true), _defineProperty(_classNames, prefixCls + '-list-item-list-type-' + listType, true), _classNames));
      var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
      var deleteSvg = {
        render: function render() {
          var h = arguments[0];

          return h(
            'svg',
            {
              attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 32 32', fill: 'currentColor' }
            },
            [h('title', [locale.removeFile]), h(
              'g',
              {
                attrs: { id: '\u56FE\u5C42_2', 'data-name': '\u56FE\u5C42 2' }
              },
              [h(
                'g',
                {
                  attrs: { id: '\u56FE\u5C42_1-2', 'data-name': '\u56FE\u5C42 1' }
                },
                [h('path', {
                  attrs: { d: 'M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm5.71,20.29a1,1,0,1,1-1.41,1.41L16,17.41l-4.29,4.29a1,1,0,0,1-1.41-1.41L14.59,16l-4.29-4.29a1,1,0,0,1,1.41-1.41L16,14.59l4.29-4.29a1,1,0,0,1,1.41,1.41L17.41,16Z' }
                })]
              )]
            )]
          );
        }
      };

      var DeleteIcon = {
        render: function render() {
          var _this3 = this;

          var h = arguments[0];

          return h(Icon, {
            attrs: {
              component: deleteSvg
            },
            on: {
              'click': function click(e) {
                return _this3.onClick(e);
              }
            },

            style: 'display: inline-block; border-radius: 100%; background-color: #fff;color: #ff4e50; font-size: 15px;'
          });
        },

        methods: {
          onClick: function onClick(e) {
            this.$emit('click', e);
          }
        }
      };
      var removeIconDefaultProps = {
        title: locale.removeFile,
        on: { click: function click(e) {
            return _this2.handleClose(e, file);
          } }
      };
      var getRemoveIconSlot = removeIconSlot && h(
        'span',
        removeIconDefaultProps,
        [removeIconSlot]
      );
      var removeIcon = showRemoveIcon ? getRemoveIconSlot || (listType === 'draggable' ? h(DeleteIcon, removeIconDefaultProps) : h(Icon, _mergeJSXProps([{
        attrs: { type: 'delete' }
      }, removeIconDefaultProps]))) : null;
      var downloadIcon = showDownloadIcon && file.status === 'done' ? h(Icon, {
        attrs: {
          type: 'download',
          title: locale.downloadFile
        },
        on: {
          'click': function click() {
            return _this2.handleDownload(file);
          }
        }
      }) : null;
      var downloadOrDelete = listType !== 'picture-card' && listType !== 'draggable' && h(
        'span',
        {
          key: 'download-delete',
          'class': prefixCls + '-list-item-card-actions ' + (listType === 'picture' ? 'picture' : '')
        },
        [downloadIcon && h(
          'a',
          {
            attrs: { title: locale.downloadFile }
          },
          [downloadIcon]
        ), removeIcon && h(
          'a',
          {
            attrs: { title: locale.removeFile }
          },
          [removeIcon]
        )]
      );
      var listItemNameClass = classNames((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-list-item-name', true), _defineProperty(_classNames2, prefixCls + '-list-item-name-icon-count-' + [downloadIcon, removeIcon].filter(function (x) {
        return x;
      }).length, true), _classNames2));

      var preview = file.url ? [h(
        'a',
        _mergeJSXProps([{
          attrs: {
            target: '_blank',
            rel: 'noopener noreferrer',

            title: file.name
          },
          'class': listItemNameClass }, linkProps, {
          attrs: {
            href: file.url
          },
          on: {
            'click': function click(e) {
              return _this2.handlePreview(file, e);
            }
          }
        }]),
        [file.name]
      ), downloadOrDelete] : [h(
        'span',
        {
          key: 'view',
          'class': prefixCls + '-list-item-name',
          on: {
            'click': function click(e) {
              return _this2.handlePreview(file, e);
            }
          },
          attrs: {
            title: file.name
          }
        },
        [file.name]
      ), downloadOrDelete];
      var style = file.url || file.thumbUrl ? undefined : {
        pointerEvents: 'none',
        opacity: 0.5
      };
      var previewIcon = showPreviewIcon ? h(
        'a',
        {
          attrs: {
            href: file.url || file.thumbUrl,
            target: '_blank',
            rel: 'noopener noreferrer',

            title: locale.previewFile
          },
          style: style,
          on: {
            'click': function click(e) {
              return _this2.handlePreview(file, e);
            }
          }
        },
        [h(Icon, {
          attrs: { type: 'eye-o' }
        })]
      ) : null;
      var actions = listType === 'picture-card' && file.status !== 'uploading' && h(
        'span',
        { 'class': prefixCls + '-list-item-actions' },
        [previewIcon, file.status === 'done' && downloadIcon, removeIcon]
      );

      var customBtns = getComponentFromProp(_this2, 'customBtns');
      customBtns && (customBtns = customBtns.filter(function (item) {
        return isValidElement(item);
      }));
      var customActions = listType === 'draggable' && file.status !== 'uploading' && customBtns && h(
        'span',
        { 'class': prefixCls + '-list-item-custom-actions' },
        [customBtns.map(function (item, index) {
          return isValidElement(item) ? h(
            'span',
            {
              on: {
                'click': function click(e) {
                  return _this2.handleCustomActions(e, file, index);
                }
              },

              'class': prefixCls + '-list-item-custom-action'
            },
            [item]
          ) : null;
        })]
      );
      var deleteAction = listType === 'draggable' && file.status !== 'uploading' && h(
        'span',
        { 'class': prefixCls + '-list-item-delete-action' },
        [removeIcon]
      );
      var message = void 0;
      var draggableMessage = void 0;
      if (file.response && typeof file.response === 'string') {
        message = file.response;
        draggableMessage = message;
      } else {
        message = file.error && file.error.statusText || locale.uploadError;
        draggableMessage = message;

        if (listType === 'draggable' && typeof file.name !== 'undefined') {
          draggableMessage = file.name;
        }
      }
      var iconAndPreview = h('span', [icon, preview]);
      var transitionProps = getTransitionProps('fade');
      var errorTips = h(
        'div',
        { 'class': prefixCls + '-list-item-error-tips' },
        [h(Icon, { 'class': prefixCls + '-list-item-error-icon', attrs: { type: 'close-circle' }
        }), h(
          'span',
          { 'class': prefixCls + '-list-item-error-text' },
          [message]
        )]
      );
      var errorTipsHover = h(
        'div',
        {
          on: {
            'click': function click(e) {
              return _this2.handleListItemRetryClick(file, e);
            }
          },

          'class': prefixCls + '-list-item-error-tips-hover'
        },
        [h(Icon, { 'class': prefixCls + '-list-item-error-retry-icon', attrs: { type: 'upload' }
        }), h(
          'span',
          { 'class': prefixCls + '-list-item-error-retry-text' },
          ['\u91CD\u65B0\u4E0A\u4F20']
        )]
      );
      var dom = h(
        'div',
        { 'class': infoUploadingClass, key: file.uid },
        [h(
          'div',
          { 'class': prefixCls + '-list-item-info' },
          [iconAndPreview]
        ), actions, customActions, deleteAction, listType === 'draggable' && file.status === 'error' ? errorTips : null, listType === 'draggable' && file.status === 'error' ? errorTipsHover : null, h(
          'transition',
          transitionProps,
          [progress]
        )]
      );
      var listContainerNameClass = classNames((_classNames3 = {}, _defineProperty(_classNames3, prefixCls + '-list-picture-card-container', listType === 'picture-card'), _defineProperty(_classNames3, prefixCls + '-list-draggable-container', listType === 'draggable'), _defineProperty(_classNames3, prefixCls + '-list-draggable-selected', listType === 'draggable' && file.isSelected), _defineProperty(_classNames3, prefixCls + '-list-draggable-disabled', listType === 'draggable' && !draggable), _classNames3));
      var listStyle = listType === 'draggable' ? {
        width: listWidth + 'px'
      } : undefined;
      return h(
        'div',
        {
          key: file.uid,
          on: {
            'click': function click(e) {
              return _this2.handleListItemClick(file, e);
            }
          },

          'class': listContainerNameClass,
          style: listStyle
        },
        [file.status === 'error' ? h(
          Tooltip,
          {
            attrs: { title: listType === 'draggable' ? draggableMessage : message }
          },
          [dom]
        ) : h('span', [dom])]
      );
    });
    var listClassNames = classNames((_classNames4 = {}, _defineProperty(_classNames4, prefixCls + '-list', true), _defineProperty(_classNames4, prefixCls + '-list-' + listType, true), _classNames4));
    var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';

    if (listType === 'draggable') {
      animationDirection = 'animate-width';
    }
    var transitionGroupProps = getTransitionProps(prefixCls + '-' + animationDirection);
    // draggableOptions
    // https://github.com/SortableJS/Sortable#options
    var _draggable$options = draggable.options,
        customizeDraggableOptions = _draggable$options === undefined ? {} : _draggable$options;

    var defaultDraggableOptions = {
      chosenClass: prefixCls + '-list-' + listType + '-draggable-chosen',
      ghostClass: prefixCls + '-list-' + listType + '-draggable-ghost',
      animation: 150,
      filter: '.' + prefixCls + '-list-item-custom-actions, .' + prefixCls + '-list-item-delete-action',
      preventOnFilter: false,
      scrollFn: this.scrollFn,
      forceFallback: true,
      scrollSensitivity: 10
    };
    var draggableOptions = _extends({}, defaultDraggableOptions, customizeDraggableOptions);
    // class
    var classes = classNames((_classNames5 = {}, _defineProperty(_classNames5, prefixCls + '-list-' + listType + '-draggable', true), _defineProperty(_classNames5, prefixCls + '-list-' + listType + '-draggable-disabled', draggableOptions.disabled), _defineProperty(_classNames5, prefixCls + '-list-' + listType + '-draggable-handle', !!draggableOptions.handle), _defineProperty(_classNames5, prefixCls + '-list-' + listType + '-dragging', this.dragging), _classNames5));

    var galleryWrapWidth = listViewLength * listOuterWidth;
    var galleryWiewWidth = list.length * listOuterWidth;
    return listType === 'draggable' && !!draggable ? h(
      Gallery,
      {
        attrs: { wrapWidth: galleryWrapWidth, viewWidth: galleryWiewWidth },
        ref: 'gallery' },
      [h(
        VueDraggable,
        {
          attrs: {
            options: draggableOptions,

            value: items
          },
          'class': classes, on: {
            'input': this.handleInput,
            'start': this.handleStart,
            'end': this.handleEnd
          }
        },
        [h(
          'transition-group',
          _mergeJSXProps([transitionGroupProps, {
            attrs: { tag: 'div' },
            'class': listClassNames }]),
          [list]
        )]
      )]
    ) : h(
      'transition-group',
      _mergeJSXProps([transitionGroupProps, {
        attrs: { tag: 'div' },
        'class': listClassNames }]),
      [list]
    );
  }
};